import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './Card.css';
import VersalDhpu from '../Button/ButtonCard/VersalDhpu'
import BntVersalDhpu from '../PopUps/BntVersalDhpu';
import { Box, Typography } from '@mui/material';

/**
 * VersalDataHandling component renders a card with Versal Data Handling information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleVersal - The callback function to handle Versal Data Handling.
 * @param {Function} props.handleVersalDecrement - The callback function to decrement Versal Data Handling.
 * @param {Function} props.reset - The callback function to reset Versal Data Handling.
 */
const VersalDataHandling = ({
  /**
   * The callback function to handle Versal Data Handling.
   */
  handleVersal, module, handleDecrement,
  /**
   * The callback function to decrement Versal Data Handling.
   */
  handleVersalDecrement,
  /**
   * The callback function to reset Versal Data Handling.
   */
  reset
}) => {
  const [open, setOpen] = useState(false);

  /**
   * Handles the click event to open the Versal Data Handling popup.
   */
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <Card variant="outlined" sx={{
      /**
       * Custom styles for the card container
       */
      width: '430px',
      height: '210px',
      border: 'none',
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
    }}>
      <CardContent>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: 'Open Sans',
              m: 0,

              fontWeight: 'bold',
            }}
          >
            Versal Data Handling Computer
          </Typography>

          <BntVersalDhpu size="small" onClick={handleClickOpen}>More Info</BntVersalDhpu>

        </Box>


        <VersalDhpu onClick={() => handleVersal(module)} handleVersalDecrement={() => handleDecrement(module)} reset={reset} />
        <p style={{
          /**
           * Custom styles for the paragraph
           */
          fontFamily: 'Open Sans',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          fontSize: '12px',
          marginRight: '16%'
        }}>
          A High-Performance, Deterministic On-Board
          Computing module in a compact ADHA-compliant
          3U module form factor        </p>

      </CardContent>
    </Card>
  );
};

/**
 * Exports the VersalDataHandling component as the default export.
 */
export default VersalDataHandling;

